import { InputRecognizer } from './input-recognizer';
export class MouseRecognizer extends InputRecognizer {
    constructor() {
        super(...arguments);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.down = (_event) => {
            this.interactionStarted = true;
        };
        this.move = (event) => {
            if (!this.interactionStarted)
                return;
            if (this.handlePan(event)) {
                this.swallowNextClick = true;
            }
        };
        this.click = (event) => {
            if (this.swallowNextClick) {
                // Prevent the click from being passed through if panning was started.
                event.preventDefault();
                event.stopImmediatePropagation();
                this.swallowNextClick = false;
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.up = (_event) => {
            this.reset();
        };
    }
    reset() {
        super.reset();
        this.interactionStarted = false;
    }
}
